module.exports = __webpack_public_path__ + "img/home_btn_img.80aada87.svg";